import {Api} from '../../api/api';

const removeItem = (parent, setPrice) => {
  const api = new Api();

  if (parent) {
    const removeButtonElement = parent.querySelector(`.js-remove-item`);
    const id = parent.dataset.id;

    let isSending = false;

    const onRemoveButtonClick = async () => {
      if (!isSending) {
        isSending = true;

        const res = await api.customQuery(`/basket/delete?idElement=${id}`, {})
          .catch(() => (isSending = false));

        if  (res.code === 200) {
          setPrice.setPrices(res.answer);
          parent.remove();
        } else {
          isSending = false;
        }
      }
    };

    removeButtonElement.addEventListener(`click`, onRemoveButtonClick);
  }
}

export {removeItem};
